import React from 'react';
import { useController } from 'react-hook-form';
import { useFormContext } from 'react-hook-form';
import useFormName from '../../../../../../Hooks/useFormName';
import StarInput from '../StarInput/StarInput';

interface Props {
	name: string;
	ratingRange: number;
	isRequired?: boolean;
}

const StarInputField: React.FC<Props> = ({ name, ratingRange }) => {
	const { fieldName } = useFormName({ name });

	const { control } = useFormContext();

	const {
		field,
		fieldState: { error },
	} = useController({
		control,
		name: fieldName,
		defaultValue: undefined,
	});

	return (
		<StarInput
			ratingRange={ratingRange}
			name={field.name}
			onChange={field.onChange}
			value={field.value}
		/>
	);
};

export default StarInputField;
